import { render, staticRenderFns } from "./LecturePreparationManage.vue?vue&type=template&id=9528ef8a&scoped=true"
import script from "./LecturePreparationManage.vue?vue&type=script&lang=ts"
export * from "./LecturePreparationManage.vue?vue&type=script&lang=ts"
import style0 from "./LecturePreparationManage.vue?vue&type=style&index=0&id=9528ef8a&prod&lang=less&scoped=true"
import style1 from "./LecturePreparationManage.vue?vue&type=style&index=1&id=9528ef8a&prod&lang=less"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9528ef8a",
  null
  
)

export default component.exports